import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgClass } from "@angular/common";
import { NgbTooltip, NgbCollapse } from "@ng-bootstrap/ng-bootstrap";
import { TranslateDirective } from "@ngx-translate/core";
import { BusySpinnerComponent } from "../busy/busy-spinner/busy-spinner.component";

@Component({
    selector: "rask-collapsable",
    styleUrls: ["./collapsable.component.scss"],
    templateUrl: "./collapsable.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        NgbTooltip,
        TranslateDirective,
        BusySpinnerComponent,
        NgbCollapse
    ]
})
export class CollapsableComponent {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("headerText") set headerInput(val: string) { this.header = val; }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("isDefaultExpanded") set isDefaultExpanded(val: boolean) { this.isCollapsed = !val; }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("badgeText") set badgeInput(val: string) { this.badge = val; }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("isWarning") set isWarningInput(val: boolean) { this.isWarning = val; }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("warningText") set warningInput(val: string) { this.warning = val; }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("faIconClass") set icon(val: string) { this.faIconClass = val; }

    @Input()showLoader: boolean;

    @Input() aid: string;

    header: string;
    badge = "";
    isCollapsed: boolean;
    isWarning: boolean;
    warning: string;
    faIconClass: string;

    @Output() accordionActive: EventEmitter<boolean> = new EventEmitter<boolean>();

    toggle() {
        this.isCollapsed = !this.isCollapsed;

        this.accordionActive.emit(!this.isCollapsed);
    }

    displayCounter(count) {
        this.badge = count;
    }

}
